export const SCREEN_RULE = 'showtime.comscore.exhibitor.market.filmPerspective';
